<template>
  <div class="fragment">
    <RequestFundsIndividualUser
            :RF="RF"
            @save="save"
    />
  </div>
</template>

<script>
  import RequestFundsIndividualUser from "./RequestFundsCreationUser/RequestFundsCreationUser";
  import {RequestFunds} from "../../models/RequestFunds";
  import {requestFunds} from "../../../../../mixins/requestFundsMixins/requestFunds";

  export default {
    name: "RequestFundsIndividual",
    components:{
      RequestFundsIndividualUser,
    },

    mixins: [requestFunds],

    watch: {
      loadUserAuthorizedData(){
        this.initializeRequestFunds()
      },
    },

    data() {
      return {
        RF: new RequestFunds(),
      }
    },

    mounted() {
      this.RF.setType(this.$route?.meta?.breadcrumbs?.type)

      if(this.loadUserAuthorizedData){
        this.initializeRequestFunds()
      }
    },

    methods: {
      initializeRequestFunds(){
        if(!this.isAdmin){
          this.RF.data.User.setUser(this.loadUserAuthorizedData?.user)
        }
      },


    },

  }
</script>

<style scoped>

</style>
